import { Component, OnInit, inject } from '@angular/core';
import { FormsModule, ReactiveFormsModule, UntypedFormGroup } from '@angular/forms';
import { FormlyFieldConfig, FormlyFormOptions } from '@ngx-formly/core';
import { MSS_FORMLY_IMPORTS } from '@shared/components/formly/formly-standalone-imports';

import { FormFieldType } from '@shared/components/formly/formly.config';
import { FormsValidators } from '@shared/components/forms/validators/forms.validators';
import { Frequency } from '@shared/models';
import { ModalService, ModalStateService } from '@shared/services';

@Component({
  selector: 'lib-add-option-modal',
  templateUrl: 'add-option-modal.component.html',
  styleUrls: ['add-option-modal.component.scss'],
  imports: [FormsModule, ReactiveFormsModule, ...MSS_FORMLY_IMPORTS],
})
export class AddOptionModalComponent implements OnInit {
  private readonly modalStateService = inject(ModalStateService);
  private readonly modalService = inject(ModalService);

  public form = new UntypedFormGroup({});
  public fields: FormlyFieldConfig[] = [];

  public formOptions: FormlyFormOptions = {};

  public ngOnInit() {
    const { optionLabel, options } = this.options?.data ?? {};
    this.fields = [
      {
        key: 'category',
        type: FormFieldType.Select,
        defaultValue: null,
        props: {
          label: optionLabel,
          options,
          required: true,
        },
      },
      {
        key: 'amount',
        type: FormFieldType.Currency,
        props: {
          label: 'Monthly amount',
          required: true,
        },
        validators: {
          validation: [FormsValidators.greaterThan(0)],
        },
      },
    ];
  }

  public get options() {
    return this.modalStateService.options;
  }

  public submit() {
    if (this.form.valid && this.options) {
      const { category, amount } = this.form.value;
      if (!this.options.data.model) {
        this.options.data.model = [];
      }
      this.options.data.model.push({ option: { category, amount, frequency: Frequency.Monthly } });

      const parentField = this.options.data.field;
      if (parentField?.form) {
        parentField.form.markAsDirty();
        parentField.form.updateValueAndValidity();
      }

      if (parentField?.formControl) {
        parentField.formControl.updateValueAndValidity();
      }

      this.modalService.close();
    }
  }

  public cancel() {
    this.modalService.dismiss();
  }
}
